<template>
    <div>
        <div class="modal-close-btn-point">
            <div class="modal-close-btn-container" @click="$emit('close')">
                <SVGModalClose/>
            </div>
        </div>
        <div class="ap-modal-title-big">
            Добавить продукт
        </div>
        <DataEntryFields @apply="apply" :buttonName="'Добавить'"/>
    </div>
</template>

<script>
import SVGModalClose from "../../../SVG/SVGModalClose";
import DataEntryFields from "./DataEntryFields";

export default {
    name: "AddProduct",
    components: {
        DataEntryFields,
        SVGModalClose
    },
    methods: {
        apply(newData) {
            this.$store.dispatch('adminPanel/products/SAVE_PRODUCTS', newData);
            this.$emit('close');
        }
    }
}
</script>

<style scoped>

</style>
